import { DateTime } from "luxon";

export function fmtDate(value?: string, format?: string) {
  if (!value) return "";
  const val = DateTime.fromISO(value);
  if (val.isValid) {
    return val.toFormat(format ?? "yyyy-MM-dd HH:mm:ss");
  }
  return "n/a";
}

export function durationInMinute(value: number) {
  if (!value) return "";
  return (value / 60).toFixed(0);
}

export function secondsToDuration(value: number) {
  if (!value) return "";
  const mins: number = Math.trunc(value / 60);
  const seconds = (value - 60 * mins).toFixed(0);
  return mins + ":" + seconds.toString().padStart(2, "0");
}

export function capitalizerFirstLetter(value: string) {
  return value
    ? value.charAt(0).toUpperCase() + value.slice(1)
    : "invalid format";
}
